import '../../css/pages/cms-page.scss';
import componentCarousel from '../modules/component-carousel/component-carousel';
import { addOffCanvasPanelListeners } from '../modules/off-canvas-panel/off-canvas-panel';
import { lighthouseImprovements } from '../modules/utility-functions/utility-functions';
import { setUpWishlistBtnEventListeners } from '../modules/wishlist/wishlist-ui';
import SetupReadmore from '../modules/readmore/readmore';
import { setUpForm } from '../pages/enquiryform';

const init = () => {
    console.log("You are on a Vybe CMS page");
    addOffCanvasPanelListeners();
    componentCarousel();
    setUpWishlistBtnEventListeners();
    lighthouseImprovements();
    if (document.querySelector('.readmore-container')) SetupReadmore();
    setUpForm();
};

const exit = () => {
    console.log("Vybe CMS Page: Exit");
};

window.cmspage = {
    init,
    exit
};